// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    position: sticky;
    display: flex;
    flex-direction: column;
}
.sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    font-family: var(--displayFont);
    font-weight: 700;
    font-size: 24px;
    box-sizing: border-box;
}
.sidebar-inner {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    max-height: 100%;
    overflow-y: auto;
}

/* Scrollbar */
.sidebar-inner::-webkit-scrollbar {
    width: 10px;
}
.sidebar-inner::-webkit-scrollbar-track {
    background: #eef;
}
.sidebar-inner::-webkit-scrollbar-thumb {
    background: #bbc;
}
.sidebar-inner::-webkit-scrollbar-thumb:hover {
    background: #99a;
}

.sidebar-item {
    display: block;
    font-size: 15px;
    font-weight: 600;
    border-left: 3px solid #00000020;
    cursor: pointer;
    color: #000;
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    background-image: linear-gradient(
        to right, 
        var(--primaryColorUltraTransparent),
        #0000 40%
    );
    background-size: 200% 100%;
    background-position: right;
    transition: background-position 0.1s ease-in-out;
    white-space: normal;
    word-wrap: break-word;
    text-overflow: ellipsis;
}
.sidebar-item:hover {
    background-color: #eef;
    text-decoration: none;
}

.si-selected {
    color: var(--primaryColorDark) !important;
    border-left: 3px solid var(--primaryColorBright) !important;
    background-position: left;
}`, "",{"version":3,"sources":["webpack://./src/styles/general/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX;;;;KAIC;IACD,0BAA0B;IAC1B,0BAA0B;IAC1B,gDAAgD;IAChD,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,2DAA2D;IAC3D,yBAAyB;AAC7B","sourcesContent":[".sidebar {\n    position: sticky;\n    display: flex;\n    flex-direction: column;\n}\n.sidebar-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 0;\n    font-family: var(--displayFont);\n    font-weight: 700;\n    font-size: 24px;\n    box-sizing: border-box;\n}\n.sidebar-inner {\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    max-height: 100%;\n    overflow-y: auto;\n}\n\n/* Scrollbar */\n.sidebar-inner::-webkit-scrollbar {\n    width: 10px;\n}\n.sidebar-inner::-webkit-scrollbar-track {\n    background: #eef;\n}\n.sidebar-inner::-webkit-scrollbar-thumb {\n    background: #bbc;\n}\n.sidebar-inner::-webkit-scrollbar-thumb:hover {\n    background: #99a;\n}\n\n.sidebar-item {\n    display: block;\n    font-size: 15px;\n    font-weight: 600;\n    border-left: 3px solid #00000020;\n    cursor: pointer;\n    color: #000;\n    padding: 10px;\n    box-sizing: border-box;\n    width: 100%;\n    background-image: linear-gradient(\n        to right, \n        var(--primaryColorUltraTransparent),\n        #0000 40%\n    );\n    background-size: 200% 100%;\n    background-position: right;\n    transition: background-position 0.1s ease-in-out;\n    white-space: normal;\n    word-wrap: break-word;\n    text-overflow: ellipsis;\n}\n.sidebar-item:hover {\n    background-color: #eef;\n    text-decoration: none;\n}\n\n.si-selected {\n    color: var(--primaryColorDark) !important;\n    border-left: 3px solid var(--primaryColorBright) !important;\n    background-position: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
